<app-table
  [config]="config"
  [customCellTemplateRef]="customCellTemplateRef" />

<ng-template
  #customCellTemplateRef
  let-column="column"
  let-model="model">
  <app-admin-box-list-custom-cell-template
    [column]="column"
    [model]="model" />
</ng-template>

<p-dialog
  [visible]="completedOrdersDialogVisibility()"
  appPrimengDialog
  header="Realizacja zamówień">

  <p class="mb-5">
    Generowanie etykiet zostało rozpoczęte. Po jego zakończeniu plik powinien zostać automatycznie pobrany.
    Pozostań na stronie aż do zakończenia procesu. Plik zostanie także umieszczony w wydaniu w magazynie.
  </p>

  @if (backgroundTaskProgress() === undefinedProgress) {
    <app-progress-bar size="15px" />
  } @else {
    <app-progress-bar size="15px" mode="determinate" [value]="backgroundTaskProgress()" />
  }

  @if (completedOrdersSimulation()) {
    <h3 class="text-center mt-5">SYMULACJA PROCESU!</h3>
  }
</p-dialog>

<p-dialog
  [visible]="downloadLabelsDialogVisibility()"
  appPrimengDialog
  header="Pobieranie etykiet">

  <p class="mb-5">
    Generowanie paczki z etykietami zostało rozpoczęte. Po jego zakończeniu plik powinien zostać automatycznie pobrany. Pozostań na stronie aż do zakończenia procesu.
  </p>

  @if (backgroundTaskProgress() === undefinedProgress) {
    <app-progress-bar size="15px" />
  } @else {
    <app-progress-bar size="15px" mode="determinate" [value]="backgroundTaskProgress()" />
  }
</p-dialog>
